export default function Card4Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M7.692 14.866c3.466 0 5.777-2.336 5.777-5.84C13.469 3.244 8.51.82 5.109.82c-.692 0-1.15.266-1.15.774 0 .197.09.4.236.578.806.971 1.504 1.961 1.517 3.161 0 .095-.007.184-.026.273-.387-.813-.984-1.231-1.536-1.231-.33 0-.552.228-.552.59 0 .216.05.54.05.876 0 1.479-1.117 2.17-1.117 4.545 0 2.691 2.057 4.481 5.161 4.481zm.159-2.088c-1.18 0-1.955-.698-1.955-1.752 0-1.092.761-1.441.863-2.234.006-.09.089-.134.171-.064.273.254.451.571.597.959.317-.515.419-1.397.298-2.343-.019-.108.064-.158.153-.12a3.561 3.561 0 0 1 2.1 3.243c0 1.27-.774 2.31-2.227 2.31z" fill="#383A3D" fillRule="nonzero" />
      </g>
    </svg>
  );
};
